import Header from "../../components/Header/Header";
import SearchInput from "../../features/StoreNews/components/SearchInput/SearchInput";
import ResultInform from "../../components/ResultInform/ResultInform";
import AfterServiceSkeleton from "../../components/Skeleton/AfterServiceSkeleton";
import Promotion from "../../components/Promotion/Promotion";
import useStoreNewsSearch from "#features/StoreNews/hooks/useStoreNewsSearch";
import StoreNewsList from "../../features/StoreNews/components/StoreNewsList/StoreNewsList";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const StoreNewsPage = () => {
  const {
    formData,
    handleChange,
    search,
    activeTab,
    handleTabClick,
    categoryKeys,
    clearInput,
    loading,
    loaded,
    branchList,
    selectBranch,
    filteredNewsList,
  } = useStoreNewsSearch();
  const { color } = useSelectBrand();

  return (
    <section className="pb-24 p-hasHeader">
      <Header title="점포 소식" />

      <Promotion
        // promoItems={landingItems}
        isStoreNews={true}
      />
      {/* 검색 탭 & 인풋 */}
      <SearchInput
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        formData={formData}
        handleChange={handleChange}
        search={search}
        categoryKeys={categoryKeys}
        clearInput={clearInput}
        branchList={branchList}
        selectBranch={selectBranch}
        color={color}
      />

      {/* 스켈레톤 로더 */}
      {loading && branchList?.length === 0 && <AfterServiceSkeleton />}

      {/* 리스트 */}
      {loaded && branchList !== null && branchList?.length > 0 && (
        <StoreNewsList newsList={filteredNewsList} />
      )}

      {/* 검색결과가 없을경우 */}
      {!loading && loaded && filteredNewsList.length === 0 && (
        <>
          {formData.keyword ? (
            <ResultInform
              label={
                <>
                  검색 결과를 <br /> 찾을 수 없습니다.
                </>
              }
            />
          ) : (
            <>
              {formData.status === "ongoing" ? (
                <ResultInform
                  label={
                    <>
                      현재 진행 중인 <br /> 행사가 없습니다.
                    </>
                  }
                />
              ) : formData.status === "upcoming" ? (
                <ResultInform
                  label={
                    <>
                      예정된 <br /> 행사가 없습니다.
                    </>
                  }
                />
              ) : (
                <ResultInform label={<>뉴스가 없습니다.</>} />
              )}
            </>
          )}
        </>
      )}
    </section>
  );
};

export default StoreNewsPage;
